module.exports = __webpack_public_path__ + "8e334ebd9f41fef399f71716ffd60541.svg";